/*eslint-disable multiline-ternary */
import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row, Button } from 'react-bootstrap';
import {
  SuccessCircle,
  ErrorCircle,
} from '../../../../img/findcare/FindCareSVG';
import { t } from 'i18next';
import { Link } from 'react-router-dom';

const ProviderInformationAccordion = ({
  locationHandler,
  doctorDetails,
  addressIndex,
  ...otherProps
}) => {
  const {
    searchProviderParams: { Network },
    address,
    networksList,
  } = useSelector(({ priceCompareAdmin }) => priceCompareAdmin);
  const { Display_Network_Indicator_for_Price_Comparison_page } = useSelector(
    (state) => state?.app?.appConfigs?.Network_Setting,
  );
  return (
    <>
      <div className="provider-information find-provider-bottom-border">
        <Row className="row m-0 p-0 mt-4">
          <Col sm={12} className="phone-info p-0">
            <p className="primary-text paragraph-font phone-info-heading m-0">
              {t('find_provider.phone')}
            </p>
            {doctorDetails?.Phone1 || doctorDetails?.Phone2 ? (
              <>
                {doctorDetails?.Phone1 !== '' && (
                  <a
                    className="secondary-text paragraph-font"
                    href={`tel:${doctorDetails?.Phone1}`}
                  >
                    {doctorDetails?.Phone1}
                  </a>
                )}
                <br />
                {doctorDetails?.Phone2 !== '' && (
                  <a
                    className="secondary-text paragraph-font"
                    href={`tel:${doctorDetails?.Phone2}`}
                  >
                    {doctorDetails?.Phone2}
                  </a>
                )}
              </>
            ) : doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone1 ||
              doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone2 ? (
              <>
                {doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone1 !==
                  '' && (
                  <a
                    className="secondary-text paragraph-font"
                    href={`tel:${doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone1}`}
                  >
                    {doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone1}
                  </a>
                )}
                <br />
                {doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone2 !==
                  '' && (
                  <a
                    className="secondary-text paragraph-font"
                    href={`tel:${doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone2}`}
                  >
                    {doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone2}
                  </a>
                )}
              </>
            ) : (
              <p className="no-data">{t('find_provider.data_not_available')}</p>
            )}
          </Col>
          <Col sm={12} className="address-info mt-4 p-0">
            <p className="primary-text paragraph-font phone-info-heading m-0">
              {t('find_provider.provider_address')}
            </p>
            {doctorDetails.DoctorAfflFacilities &&
            doctorDetails.DoctorAfflFacilities.length ? (
              <p className="secondary-text paragraph-font m-0">
                {doctorDetails.DoctorAfflFacilities[addressIndex]
                  .AddressLine1 &&
                  doctorDetails.DoctorAfflFacilities[addressIndex]
                    .AddressLine1 + ', '}
                {doctorDetails.DoctorAfflFacilities[addressIndex]
                  .AddressLine2 &&
                  doctorDetails.DoctorAfflFacilities[addressIndex]
                    .AddressLine2 + ', '}
                {doctorDetails.DoctorAfflFacilities[addressIndex]
                  .AddressLine3 &&
                  doctorDetails.DoctorAfflFacilities[addressIndex]
                    .AddressLine3 + ', '}
                {doctorDetails.DoctorAfflFacilities[addressIndex].City &&
                  doctorDetails.DoctorAfflFacilities[addressIndex].City + ', '}
                {doctorDetails.DoctorAfflFacilities[addressIndex].County &&
                  doctorDetails.DoctorAfflFacilities[addressIndex].County +
                    ', '}
                {doctorDetails.DoctorAfflFacilities[addressIndex].State &&
                  doctorDetails.DoctorAfflFacilities[addressIndex].State + ', '}
                {doctorDetails.DoctorAfflFacilities[addressIndex].PostalCode &&
                  doctorDetails.DoctorAfflFacilities[addressIndex].PostalCode}
              </p>
            ) : (
              <p className="no-data">{t('find_provider.data_not_available')}</p>
            )}
            <Button
              className=" p-0 m-0 paragraph-font secondary-2 provider-location-link mt-2"
              variant="link"
              onClick={locationHandler}
            >
              {t('find_provider.change_provider_location')}
            </Button>
          </Col>
          <Col sm={12} className="p-0 mt-4">
            <p className="secondary-text paragraph-font">
              <Link
                to={{
                  pathname: 'https://www.google.com/maps/dir/',
                  search: `?api=1&origin=${address}&destination=${
                    doctorDetails.DoctorAfflFacilities?.length > 0 &&
                    doctorDetails.DoctorAfflFacilities[addressIndex]
                      .Coordinateds &&
                    doctorDetails.DoctorAfflFacilities[addressIndex]
                      .Coordinateds
                  }`,
                }}
                target="_blank"
              >
                <span className="secondary-2">
                  {t('find_provider.directions')}
                </span>
              </Link>
              <br />
              {doctorDetails.DoctorAfflFacilities?.length > 0 &&
                doctorDetails.DoctorAfflFacilities[addressIndex].Distance &&
                `${
                  doctorDetails.DoctorAfflFacilities[addressIndex].Distance
                } mile${
                  Number(
                    doctorDetails.DoctorAfflFacilities[addressIndex].Distance,
                  ) > 1
                    ? 's'
                    : ''
                }`}
            </p>
          </Col>
        </Row>
        <Row className="row m-0 p-0 pt-4 pb-3">
          <Col sm={12} className="patient-accept p-0">
            <button
              disabled
              className={`${
                doctorDetails?.DoctorAfflFacilities[addressIndex]
                  ?.AcceptingNewPatients
                  ? 'accept-new-patient-success'
                  : 'accept-new-patient-danger'
              } d-block`}
            >
              <div className="d-flex align-items-center">
                {doctorDetails?.DoctorAfflFacilities[addressIndex]
                  ?.AcceptingNewPatients ? (
                  <>
                    <SuccessCircle className="success-circle" />
                    <span>{t('find_provider.accepting_new_patients')}</span>
                  </>
                ) : (
                  <>
                    <ErrorCircle className="danger-circle" />
                    <span>
                      {t('find_provider.not')}{' '}
                      {t('find_provider.accepting_new_patients')}
                    </span>
                  </>
                )}
              </div>
            </button>

            {Display_Network_Indicator_for_Price_Comparison_page ? (
              <button
                disabled
                className={`${
                  doctorDetails?.DoctorAfflFacilities[addressIndex]?.InNetwork
                    ? 'in-network-success'
                    : 'in-network-danger'
                } mt-2 d-block`}
              >
                <div className="d-flex align-items-center">
                  {doctorDetails?.DoctorAfflFacilities[addressIndex]
                    ?.InNetwork ? (
                    <>
                      <SuccessCircle className="success-circle" />
                      <span>{t('find_provider.in_network')}</span>
                    </>
                  ) : (
                    <>
                      <ErrorCircle className="danger-circle" />
                      <span>{t('find_provider.out_of_network')}</span>
                    </>
                  )}
                </div>
              </button>
            ) : (
              ''
            )}
          </Col>
          <Col sm={12} className="p-0 mt-3">
            <div className="patient-satisfaction primary-background pl-2 my-2">
              <p className="patient-satisfaction-lalbel mb-2">
                {t('find_provider.patient_satisfaction')}
              </p>
              {doctorDetails?.DoctorAfflFacilities[addressIndex]
                ?.PatientSatisfaction &&
              doctorDetails?.DoctorAfflFacilities[addressIndex]
                ?.PatientSatisfaction !== '' ? (
                <p className="secondary-text paragraph-font">
                  {
                    doctorDetails?.DoctorAfflFacilities[addressIndex]
                      ?.PatientSatisfaction
                  }
                </p>
              ) : (
                <p className="no-data">
                  {t('find_provider.data_not_available')}
                </p>
              )}
            </div>
          </Col>
        </Row>
      </div>
      {doctorDetails?.DoctorAfflFacilities[addressIndex]?.InNetwork && (
        <div className="find-provider-bottom-border find-provider-network-info">
          <Row className="m-0 p-0 pt-4 pb-3 network-section">
            <p className="w-100 primary-text paragraph-font provider-details-heading">
              {t('find_provider.networks')}
            </p>
            {doctorDetails.DoctorAfflFacilities?.length &&
            doctorDetails.DoctorAfflFacilities[addressIndex]?.Networks
              ?.length ? (
              doctorDetails.DoctorAfflFacilities[addressIndex].Networks.map(
                (item, index) =>
                  networksList.findIndex((ele) => ele.value === item) !==
                    -1 && (
                    <Col sm={4} className="p-0 mb-2" key={index}>
                      {Network === item ? (
                        <p className="font-weight-bold provider-details-data">
                          <SuccessCircle className="success-circle" />
                          <span className="ml-2">{item}</span>
                        </p>
                      ) : (
                        <p className="provider-details-data">
                          <span>{item}</span>
                        </p>
                      )}
                    </Col>
                  ),
              )
            ) : (
              <p className="no-data">{t('find_provider.data_not_available')}</p>
            )}
          </Row>
        </div>
      )}
      <div className="provider-professional-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.professional_details')}
          </p>
          <Col sm={12} className="p-0">
            <Row>
              <Col sm={4}>
                <p className="provider-details-sub-heading">
                  {t('find_provider.specialties')}
                </p>
                {doctorDetails.DoctorAfflFacilities?.length &&
                doctorDetails.DoctorAfflFacilities[addressIndex]?.Specialties &&
                doctorDetails.DoctorAfflFacilities[addressIndex]?.Specialties
                  .length ? (
                  doctorDetails.DoctorAfflFacilities[
                    addressIndex
                  ].Specialties.map((item, index) => (
                    <p className="provider-details-data" key={index}>
                      {item}
                    </p>
                  ))
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.medical_school_education')}
                </p>
                {doctorDetails.MedicalSchoolEducation &&
                doctorDetails.MedicalSchoolEducation.length ? (
                  doctorDetails.MedicalSchoolEducation.map((item, index) => (
                    <p className="provider-details-data" key={index}>
                      {item}
                    </p>
                  ))
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.board_certification')}
                </p>
                {doctorDetails.BoardCertifications &&
                doctorDetails.BoardCertifications.length ? (
                  doctorDetails.BoardCertifications.map((item, index) => (
                    <p className="provider-details-data" key={index}>
                      {item}
                    </p>
                  ))
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.experience')}
                </p>
                {doctorDetails.Experience ? (
                  <p className="provider-details-data">
                    {doctorDetails.Experience}
                  </p>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.awards_and_recognitions')}
                </p>
                {doctorDetails.AwardsAndRecognition ? (
                  <p className="provider-details-data">
                    {doctorDetails.AwardsAndRecognition}
                  </p>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.affiliations')}
                </p>
                {doctorDetails.DoctorAfflFacilities?.length > 0 ? (
                  <Button
                    className="provider-details-data-secondary cursor-pointer affiliations-button text-lowercase"
                    onClick={() => otherProps.makeAffiliationsActive()}
                    variant="link"
                  >
                    {`${doctorDetails.DoctorAfflFacilities.length} affiliation${
                      doctorDetails.DoctorAfflFacilities.length > 1 ? 's' : ''
                    }`}
                  </Button>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.license_type')}
                </p>
                {doctorDetails.LicenseType ? (
                  <p className="provider-details-data">
                    {doctorDetails.LicenseType}
                  </p>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.license_number')}
                </p>
                {doctorDetails.LicenseNumber ? (
                  <p className="provider-details-data">
                    {doctorDetails.LicenseNumber}
                  </p>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.national_provider_id')}
                </p>
                {doctorDetails.ProviderId ? (
                  <p className="provider-details-data">
                    {doctorDetails.ProviderId}
                  </p>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div className="provider-office-hours-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.office_hours')}
          </p>
          <Col sm={12} className="p-0">
            {doctorDetails.DoctorAfflFacilities?.length &&
            doctorDetails.DoctorAfflFacilities[addressIndex]?.OfficeHours &&
            doctorDetails.DoctorAfflFacilities[addressIndex]?.OfficeHours
              .length ? (
              doctorDetails.DoctorAfflFacilities[addressIndex].OfficeHours.map(
                (item, index) => (
                  <p className="row mb-0" key={index}>
                    <span className="col-4 provider-details-data">
                      {item.Day}
                    </span>
                    <span className="col-8 hours-info">{item.Time}</span>
                  </p>
                ),
              )
            ) : (
              <p className="no-data">{t('find_provider.data_not_available')}</p>
            )}
          </Col>
          <p className="w-100 primary-text paragraph-font provider-details-sub-heading mt-4">
            {t('find_provider.same_day_appointment')}
          </p>
          {doctorDetails?.DoctorAfflFacilities[addressIndex]
            ?.SameDayAppointment !== undefined ? (
            <p className="provider-details-data">
              {doctorDetails?.DoctorAfflFacilities[addressIndex]
                ?.SameDayAppointment
                ? 'Available'
                : 'Not Available'}{' '}
            </p>
          ) : (
            <p className="no-data">{t('find_provider.data_not_available')}</p>
          )}
        </Row>
      </div>
      <div className="provider-facilities-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.facilities_location')}
          </p>
          {doctorDetails.DoctorAfflFacilities?.length &&
          doctorDetails.DoctorAfflFacilities[addressIndex]?.FacilitiesAtLocation
            ?.length ? (
            doctorDetails.DoctorAfflFacilities[
              addressIndex
            ].FacilitiesAtLocation.map((item, index) => (
              <p className="provider-details-data w-100 mb-2" key={index}>
                {item}
              </p>
            ))
          ) : (
            <p className="no-data">{t('find_provider.data_not_available')}</p>
          )}
        </Row>
      </div>
    </>
  );
};

export default ProviderInformationAccordion;
